import { defineStore } from 'pinia'

export const useGeneralStore = defineStore('general', {
    state: () => {
        return {
            latitude: -4.008916,
            longitude:  -79.206306,
            zoom: 5
        }
    }
})